import { type FC } from "react";
import cx from "classnames";
import { AppImage } from "@/components";
import blackListIcon from "@/assets/images/black-list.svg";
import styles from "./RiskIndicatorBlackList.module.sass";

interface RiskIndicatorBlackListProps {
  note: string;
  className?: string;
}

const RiskIndicatorBlackList: FC<RiskIndicatorBlackListProps> = ({
  note,
  className,
}) => {
  return (
    <div className={cx(styles.risk, className)}>
      <div className={styles.inner}>
        <div className={styles.gray} />
      </div>
      <div className={styles.levelWhite}>
        <div className={styles.value}>
          <AppImage src={blackListIcon} alt="" className={styles.valueIcon} />
          <div className={styles.valueNote}>{note}</div>
        </div>
      </div>
      <div className={styles.from}>0</div>
      <div className={styles.to}>100</div>
    </div>
  );
};

export default RiskIndicatorBlackList;
